import React from 'react';
import withAuth from "../../../../services/withAuth";
import Header from "../../../../components/Header";
import {Redirect, Prompt} from "react-router-dom";
import PageTitle from "../../../../components/PageTitle";
import LoadingSpinner from "../../../../components/LoadingSpinner/index";
import moment from "moment/moment";
import MembersApi from "../../../../services/portal-api/MembersApi";
import InnerTable from "./components/InnerTable";
import TextInput from "../../../../components/Form/components/TextInput";
import SelectInput from "../../../../components/Form/components/SelectInput";
import swal from "sweetalert";
import AuthService from '../../../../services/AuthService';
import NotFound from '../../../NotFound';

//import "react-datepicker/dist/react-datepicker.css";

class TransactionHistory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pretable: [],
            isLoadingTransaction: true,
            isDownloadingTransaction: false,
            offset : 0,
            limit: 50,
            loadmore: false,
            result: {},
            filterColumn: '',
            filterToken: '',
            filterDateFrom: '',
            filterDateTo: '',
            detailShown: [],
            totalPrice: {},
            totalQty: {},
            screenh:'',
        };

        this.handleLoadMore = this.handleLoadMore.bind(this);
    }

    componentDidMount() {
        MembersApi.getPurchaseHistory((result)=>{
            if (result.success) {
                let cmo = this.transactionData(result.json.data);
                let offset = this.state.limit + this.state.offset;
                let loadmore = result.json.loadMore;
                this.setState({
                    pretable: cmo,
                    isLoadingTransaction : false,
                    offset: offset,
                    loadmore: loadmore,
                    screenh: window.innerHeight,
                });
            } else {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoadingTransaction: false,
                    });
                    return;
                } else {
                    // alert("Something went wrong.")
                    swal("Something went wrong", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });
                }
            }            
        },this.props.match.params.id,this.state.offset);
    }

    _innerTableSession = (response) => {
        if (response.status === 401) {
            this.props.sessionExpired();
            this.setState({
                isLoadingTransaction: false,
            });
            return;
        } else {
            // alert("Something went wrong.")
            swal("Something went wrong", {
                icon: "warning",
                buttons: false,
                timer: 3000
            });
        }
    }

    handleLoadMore(event){
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        this.setState({isLoadingTransaction : true,});
        MembersApi.getPurchaseHistory((result)=>{
            if (result.success) {
                let cmo = this.transactionData(result.json.data);
                let offset = this.state.limit + this.state.offset;
                let loadmore = result.json.loadMore;
                this.setState({
                    pretable: cmo,
                    isLoadingTransaction: false,
                    offset: offset,
                    loadmore: loadmore,
                    screenh: window.innerHeight,
                });
            }  else {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoadingTransaction: false,
                    });
                    return;
                } else {
                    // alert("Something went wrong.")
                    swal("Something went wrong", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });
                }
            }           
        },this.props.match.params.id,this.state.offset,this.state.filterColumn,this.state.filterToken,offset,tz);
    }

    toggleShown = (event) => {
        let shownState = this.state.detailShown.slice();
        let r = this.state.result;
        let index = shownState.indexOf(event.target.getAttribute('data-tran'));
        if (index >= 0) {
          shownState.splice(index, 1);
          this.setState({
            detailShown: shownState,
            screenh: window.innerHeight,
          });
        } else {
          shownState.push(event.target.getAttribute('data-tran'));
          this.setState({
            detailShown: shownState,
            screenh: window.innerHeight,
          });
        }
    }

    handleReset = (event) => {
        const category = this.state.category;
        this.setState({
            pretable: [],
            isLoadingTransaction: true,
            offset : 0,
            limit: 50,
            loadmore: false,
            result: {},
            filterColumn: '',
            filterToken: '',
            filterDateFrom: '',
            filterDateTo: '',
            detailShown: [],
            totalPrice: {},
            totalQty: {},
            screenh:'',
            startDate: new Date(),
        },()=>{
            MembersApi.getPurchaseHistory((result)=>{
                if (result.success) {
                    let cmo = this.transactionData(result.json.data);
                    let offset = this.state.limit + this.state.offset;
                    let loadmore = result.json.loadMore;
                    this.setState({
                        pretable: cmo,
                        isLoadingTransaction : false,
                        offset: offset,
                        loadmore: loadmore,
                        screenh: window.innerHeight,
                    });
                } else {
                    if (result.status === 401) {
                        this.props.sessionExpired();
                        this.setState({
                            isLoadingTransaction: false,
                        });
                        return;
                    } else {
                        // alert("Something went wrong.")
                        swal("Something went wrong", {
                            icon: "warning",
                            buttons: false,
                            timer: 3000
                        });
                    }
                }            
            },this.props.match.params.id,this.state.offset,this.state.filterColumn,this.state.filterToken);
        });
    }

    handleInput = (event) =>{
       const names = event.target.name;
       if(names == "filterBy"){
            const column = event.target.value;
            this.setState({
                    filterColumn : column,
                    filterToken : '',
            });
        } else {
            const token = event.target.value;
            if(names == 'Date_To'|| names == 'Date_From'){
                
                if(names == 'Date_From'){
                    this.setState({
                        filterDateFrom : token,
                    },()=>{
                        let to = this.state.filterDateTo;
                        let from = this.state.filterDateFrom;
                        this.setState({
                            filterToken : from+"|"+to,   
                        });
                    });
                } else {
                    this.setState({
                        filterDateTo : token,
                    },()=>{
                        let to = this.state.filterDateTo;
                        let from = this.state.filterDateFrom;
                        this.setState({
                            filterToken : from+"|"+to,   
                        });
                    });
                }
    
            } else {
                this.setState({
                    filterToken : token,
                });
            }
        }
    }

    handleSubmit = (event) => {

        // Prevent default behaviour
        event.preventDefault();
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        this.setState({isLoadingTransaction : true,offset: 0,pretable:[]},()=>{
            MembersApi.getPurchaseHistory((result)=>{
                if (result.success) {
                    let cmo = this.transactionData(result.json.data);
                    let offset = this.state.limit + this.state.offset;
                    let loadmore = result.json.loadMore;
                    this.setState({
                        pretable: cmo,
                        isLoadingTransaction : false,
                        offset: offset,
                        loadmore: loadmore,
                        screenh: window.innerHeight,
                    });
                }  else {
                    if (result.status === 401) {
                        this.props.sessionExpired();
                        this.setState({
                            isLoadingTransaction: false,
                        });
                        return;
                    } else {
                        // alert("Something went wrong.")
                        swal("Something went wrong", {
                            icon: "warning",
                            buttons: false,
                            timer: 3000
                        });
                    }
                } 
            },this.props.match.params.id,this.state.offset,this.state.filterColumn,this.state.filterToken,offset,tz);
        });
    }

    transactionData(result){
        const table_render = this.state.pretable;
        result.forEach((kmm,index) => {
            table_render.push(kmm);
        });
        return table_render;
    }
    
    datepick = (date) => {
        this.setState({
            startDate: date,
        })
    }
    
    csvac = () => {
        this.setState({isDownloadingTransaction:true},()=>{
            const localTime = new Date();
            let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let offset = localTime.getTimezoneOffset();
            MembersApi.downloadAsCsv(this.props.match.params.id,0,this.state.filterColumn,this.state.filterToken,offset,tz,(href)=>{
                if(href){
                    this.setState({isDownloadingTransaction:false});
                }
            });
        });
        
    } 

    render() {
        
        const viewUrl = this.props.location.state != undefined ? this.props.location.state.prevPath : "/";
        if (this.state.viewSlug) {
            return (<Redirect to={viewUrl} />);
        }

        let pageTitle = 'Recent Transaction History';
        let contents = [];
        let selections = [{key:"Transaction_No", value:"Transaction No."},{key:"Item", value:"Item Name/No"},{key:"Branch_Name", value:"Branch Name/No"},{key:"Date", value:"Date Range"}];
        this.state.pretable.forEach((kmm,index) => {
            contents.push(<React.Fragment key={index}>
                <tr>
                    <td style={{background:'#f3f7eb'}}><span data-tran={kmm.Transaction_No} onClick={this.toggleShown} style={{border: '1px solid #a9a9a9',padding: 2,background: '#fff',marginRight: 14,paddingLeft: 5}}> {this.state.detailShown.includes(kmm.Transaction_No) ? ' - ': ' + '} </span><strong data-col="Transaction_No">{kmm.Transaction_No}</strong></td>
                    <td style={{background:'#f3f7eb'}}><strong data-col="Card_No">{kmm.Card_No}</strong></td>
                    <td style={{background:'#f3f7eb'}}><strong>{kmm.Branch_No}</strong></td>
                    <td style={{background:'#f3f7eb'}}><strong data-col="Branch_Name">{kmm.Branch_Name}</strong></td>
                    <td style={{background:'#f3f7eb'}}><strong data-col="Date">{kmm.Date}</strong></td>
                    <td style={{background:'#f3f7eb'}}><strong>{kmm.Total_Qty}</strong></td>
                    <td style={{background:'#f3f7eb',textAlign:'right'}}><strong>{kmm.Branch_No > 20000 ? "NZD" : "AUD"} {kmm.Total_Price}</strong></td>
                </tr>
                <React.Fragment>{ this.state.detailShown.includes(kmm.Transaction_No) && <tr><td colSpan="7"><InnerTable tranId={kmm.Transaction_No} cur={kmm.Branch_No > 20000 ? "NZD" : "AUD"} tranColumn="Transaction_No" givex={this.props.match.params.id} sessionLogger={this._innerTableSession}></InnerTable></td></tr>}</React.Fragment>
            </React.Fragment>);
        });

        $(document).ready(function(){
            $('.scrollToTop').hide();
            console.log(window.innerHeight);
                //Check to see if the window is top if not then display button
                $(window).scroll(function(){
                    if ($(this).scrollTop() > 300) {
                        console.log("sd");
                        $('.scrollToTop').show();
                    } else {
                        $('.scrollToTop').hide();
                    }
                });
                
            });

            let loaderOffset = {
                top:200,
                position:'absolute',
                left:'50%',
            }    
            
            if(this.state.offset != 0){
    
                loaderOffset = {
                    bottom:400,
                    position:'absolute',
                    left:'50%',
                }   
            } 

        return(
            AuthService.can('View purchase history') ?
            <div>
               <Header />
                <main className="content" role="main">
                    <div className="container container--wide padding--60">

                        <header className="header--page clearfix">

                        <PageTitle back={viewUrl} title={pageTitle} />

                        </header>

                        <div className="margin--60--top validate">
                        <form onSubmit={this.handleSubmit}>
                            <div className="col">
                                    <div className={this.state.filterColumn != "Date"?"col-4 gutter--40":"col-5 gutter--40"} style={{borderBottom:'1px solid #ccc'}}>
                                        <div className="col">
                                            <SelectInput
                                                name="filterBy"
                                                label="Search By"
                                                options={selections}
                                                value={this.state.filterColumn}
                                                onChange={this.handleInput}
                                                disabled={false}
                                            />
                                        </div>
                                        {this.state.filterColumn == "Transaction_No" && <div className="col">
                                            <TextInput
                                                name="Transaction_No"
                                                label="Transaction No."
                                                placeholder="Enter .."
                                                value={this.state.filterToken}
                                                onChange={this.handleInput}
                                                required={true}
                                            />
                                        </div>}
                                        {this.state.filterColumn == "Branch_Name" && <div className="col">
                                            <TextInput
                                                name="Branch_Name"
                                                label="Branch Name/No"
                                                placeholder="Enter .."
                                                value={this.state.filterToken}
                                                onChange={this.handleInput}
                                            />
                                        </div>}
                                        {this.state.filterColumn == "Item" && <div className="col">
                                            <TextInput
                                                name="Card_No"
                                                label="Item Name/No."
                                                placeholder="Enter .."
                                                value={this.state.filterToken}
                                                onChange={this.handleInput}
                                            />
                                        </div>}
                                        {this.state.filterColumn == "Date" && <div className="col">
                                            <TextInput
                                                    name="Date_From"
                                                    label="Date From"
                                                    placeholder="DD/MM/YYYY"
                                                    value={this.state.filterDateFrom}
                                                    onChange={this.handleInput}
                                                />
                                        </div>}
                                        {this.state.filterColumn == "Date" && <div className="col">
                                            <TextInput
                                                name="Date_To"
                                                label="Date To"
                                                placeholder="DD/MM/YYYY"
                                                value={this.state.filterDateTo}
                                                onChange={this.handleInput}
                                            />
                                        </div>}
                                        {this.state.filterColumn != '' && <div className="col" style={{paddingTop: 41}}>
                                            <button type="submit" className="btn btn--small btn--color" style={{marginRight:6}}>Search</button>
                                            <button className="btn btn--small btn--color" onClick={this.handleReset}>Reset</button>
                                        </div>}

                                        <div className="col" style={{paddingTop: 65,float:"right"}}>
                                             <button className="btn btn--xsmall btn--blue" style={{float:"right",cursor:"pointer"}} onClick={this.csvac}> {this.state.isDownloadingTransaction ? "Downloading CSV ":"Download as CSV "} {this.state.isDownloadingTransaction && <img className="icon" src="/img/Gear-job.gif" style={{width:20,height:20,top:"34%",marginTop:-5,right:8}}></img>}</button>
                                        </div>
                                        </div>
                                    
                                </div>
                        </form>
                        <div className="table--overflow clearfix" style={{overflowY:"auto"}}>
                           
                        <table>
                                <thead>
                                    <tr>
                                        <th style={{position:'sticky',top:0,background:'#fff',zIndex:999,verticalAlign:'top'}}>Transaction Id</th>
                                        <th style={{position:'sticky',top:0,background:'#fff',zIndex:999,verticalAlign:'top'}}>Card No.</th>
                                        <th style={{position:'sticky',top:0,background:'#fff',zIndex:999,verticalAlign:'top'}}>Branch No.</th>
                                        <th style={{position:'sticky',top:0,background:'#fff',zIndex:999,verticalAlign:'top'}}>Branch Name</th>
                                        <th style={{position:'sticky',top:0,background:'#fff',zIndex:999,verticalAlign:'top'}}>Sale Date</th>
                                        <th style={{position:'sticky',top:0,background:'#fff',zIndex:999,verticalAlign:'top'}}>Qty</th>
                                        <th style={{position:'sticky',top:0,background:'#fff',zIndex:999,verticalAlign:'top',textAlign:'right'}}>Amount</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {contents}
                                    {contents.length === 0 &&
                                        <tr>
                                            <td colSpan="7">No results founds.</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                            {this.state.loadmore && <button onClick={this.handleLoadMore} style={{position:"relative",left:"50%",bottom:20,marginTop:60,zIndex:9999,padding: '5px 5px 5px',fontSize:12,borderRadius:23,background:"#2170c3",fontWeight:600,color:"white",width:112,boxShadow:'0px 0px 6px #58626c'}}>load more</button>}
                            {this.state.isLoadingTransaction && <div style={{position: 'absolute',height: '100%',width: '100%',top: 0,background: '#fff',zIndex: 7777,opacity: 0.8}}>
                                <div className="sk-fading-circle" style={loaderOffset}>
                                    <div className="sk-circle1 sk-circle" />
                                    <div className="sk-circle2 sk-circle" />
                                    <div className="sk-circle3 sk-circle" />
                                    <div className="sk-circle4 sk-circle" />
                                    <div className="sk-circle5 sk-circle" />
                                    <div className="sk-circle6 sk-circle" />
                                    <div className="sk-circle7 sk-circle" />
                                    <div className="sk-circle8 sk-circle" />
                                    <div className="sk-circle9 sk-circle" />
                                    <div className="sk-circle10 sk-circle" />
                                    <div className="sk-circle11 sk-circle" />
                                    <div className="sk-circle12 sk-circle" />
                                </div>
                            </div>}
                        </div>

                        </div>
                        

                    </div>
                    <div className="scrollToTop" title="scroll to top" style={{position:"absolute",bottom:30, right: 30,cursor:'pointer', borderRadius:34, boxShadow:'0px 1px 7px #444',width:40,height:40,transform: 'rotateZ(180deg)',padding:8,textAlign:'center'}} onClick={()=>{window.scrollTo({top: 0,behavior: 'smooth',});}}>V</div>
                    </main>
            </div>
            : <NotFound forbidden={true} />
        );
    }

}
export default withAuth(TransactionHistory);